import moment from 'moment';
import * as constants from '../../constants';

export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const propertyTypeFormatter = (row) => {
    const propAbbrevs = [
        { 'psc318': 'R' },
        { 'psc319': 'CL' },
        { 'psc320': 'NB' },
        { 'psc321': 'COM' },
        { 'psc322': 'HUD' },
        { 'psc323': 'VA' },
        { 'psc324': 'BO' },
        { 'psc325': 'MF' },
        { 'psc326': 'GR' },
        { 'psc327': 'A' },
        { 'psc328': 'S' },
        { 'psc433': 'RL' },
        { 'psc636': 'CR' },
        { 'psc637': 'RR' },
    ];

    const subCategories = row.subCategories;
    var abbrev = [];
    const fullNameList = [];
    
    if (subCategories != null && row.categoryId !== constants.MAILMERGECATEGORY_AGENT && row.categoryId !== constants.MAILMERGECATEGORY_RENTAL) {
        subCategories.forEach((propType) => {
            var propAbbrev = propAbbrevs.find((propAbbrev) => { return propAbbrev['psc' + propType.subCategoryId] !== undefined; })

            if (propAbbrev !== undefined) {
                abbrev.push(propAbbrev['psc' + propType.subCategoryId]);
                fullNameList.push(propType.subCategory.name);
            }
        });

        abbrev = (abbrev.length > 0) ? abbrev.join() : '';
    } else {
        abbrev = ''
    }

    return <span title={fullNameList.join(", ")}>{abbrev}</span>;
};

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: () => {
            return { width: '200px', ...headerStyle() };
        },
    },
    {
        dataField: 'category',
        text: 'Plan Category',
        sort: true,
        headerStyle: () => {
            return { width: '200px', ...headerStyle() };
        },
    },
    {
        dataField: 'subCategories',
        text: 'Property Type',
        sort: true,
        headerStyle: () => {
            return { width: '200px', ...headerStyle() };
        },
        style: columnStyle,
        formatter: (_cell, row) => propertyTypeFormatter(row),
    },
    {
        dataField: 'createdOn',
        text: 'Created Date',
        sort: true,
        headerStyle: () => {
            return { width: '100px', ...headerStyle() };
        },
        formatter: (_cell, row) => {
            return moment(row.createdOn).format('YYYY-MM-DD');
        }
    },
];

export const sorting = [{
    dataField: 'createdOn',
    order: 'desc'
}];